import { Calculator, FileCheck2, Landmark, LockKeyhole, Search } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

import { itemPorCaminho } from '@/nucleo/navegacao/mapa';
import { Button } from '@/ui/base/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/ui/base/card';

const atalhos = [
  { caminho: '/operacao/financeiro/apuracao-mensal', icone: Calculator },
  { caminho: '/operacao/financeiro/fechamento-mensal', icone: LockKeyhole },
  { caminho: '/operacao/financeiro/ciclo-financeiro', icone: FileCheck2 },
  { caminho: '/operacao/financeiro/sof', icone: Landmark },
] as const;

export function FinanceiroInicio() {
  const { pathname } = useLocation();
  const item = itemPorCaminho(pathname);
  const titulo = item?.titulo ?? 'Financeiro';

  return (
    <div className="space-y-6">
      <div>
        <p className="text-sm font-medium text-muted-foreground">Apuração e financeiro</p>
        <h1 className="text-3xl font-semibold tracking-tight">{titulo}</h1>
        <p className="mt-2 max-w-3xl text-muted-foreground">
          Fluxo financeiro do TEG com dados reais do sistema. Os registros exibidos dependem do
          escopo de acesso e da competência selecionada.
        </p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {atalhos.map(({ caminho, icone: Icon }) => {
          const atalho = itemPorCaminho(caminho);
          return (
            <Card key={caminho}>
              <CardHeader>
                <Icon className="h-5 w-5 text-primary" aria-hidden="true" />
                <CardTitle className="text-base">{atalho?.titulo}</CardTitle>
                <CardDescription>{atalho?.resumo}</CardDescription>
              </CardHeader>
              <CardContent>
                <Button asChild variant="outline" className="w-full">
                  <Link to={caminho}>Abrir tela</Link>
                </Button>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-base">
            <Search className="h-4 w-4" aria-hidden="true" />
            Dados do módulo
          </CardTitle>
          <CardDescription>
            As telas estão organizadas por competência, ciclo de pagamento e integração SOF.
          </CardDescription>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          Selecione uma jornada acima ou use a navegação lateral para acessar as telas do módulo.
        </CardContent>
      </Card>
    </div>
  );
}

export default FinanceiroInicio;
